import { Col, Form, Input, Row } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../apis/store";
import Selects from "../../../../biblio/Selects/Selects";
import Inputs from "../../../../biblio/Inputs/Inputs";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import {
  addEducationMonitoring,
  getGeneralEducationMonitoring,
} from "../../../../apis/actions/monitoring.actions";
import { showNotitfication } from "../../../../components/utils/utils";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import { handleFileChange } from "../fileUtils";
import { setResModel, setResIds } from "../../../../apis/slices/ratingSlice";

const { TextArea } = Input;
interface AddRegistrationRequestProps {
  beneficiary: any;
  subjects: any;
  academicYears: any;
  setIsModalVisible: any;
  isModalVisible: any;
}

const AddRegistrationSchoolRequest = ({
  beneficiary,
  subjects,
  academicYears,
  setIsModalVisible,
  isModalVisible,
}: AddRegistrationRequestProps) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [loadingSend, setLoadingSend] = useState(false);

  const onFinish = async () => {
    try {
      await form.validateFields();
      setLoadingSend(true);
      const FormValues = form.getFieldsValue();

      const requestsFormData = {
        ...FormValues,
        partner_id: form.getFieldValue("partner_id").value,
        academic_year_id: form.getFieldValue("academic_year_id").value,
        subject_id: form.getFieldValue("subject_id").value,
      };
      dispatch(addEducationMonitoring(requestsFormData)).then((result: any) => {
        const request = result?.payload?.result;
        if (request?.code === 200) {
          dispatch(setResModel(request?.res_model));
          dispatch(setResIds([request?.education_monitoring_id]));
          showNotitfication(request?.message, "success", dispatch);
          form.resetFields();
          setIsModalVisible(false);
          dispatch(getGeneralEducationMonitoring({ limit: 8, page: 1 }));
          setLoadingSend(false);
        } else {
          showNotitfication(request?.message, "error");
          setIsModalVisible(false);
          setLoadingSend(false);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <ModalComponent
      title=""
      open={isModalVisible}
      onClose={() => setIsModalVisible(false)}
      closeOnOutsideClick={true}
      width={800}
      modalStyle={{ top: 200 }}
      destroyOnClose
    >
      <Row justify={"center"}>
        <p className="takaful--confirm-logout">إنشاء طلب متابعة تعليمية</p>
      </Row>
      <Form
        dir="rtl"
        form={form}
        layout="vertical"
        style={{ paddingTop: "1.5rem" }}
      >
        <Row gutter={16}>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="partner_id"
              label="المستفيد"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects
                options={beneficiary}
                className="takaful--request-select"
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="subject_id"
              label="المادة الدراسية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects options={subjects} className="takaful--request-select" />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="academic_year_id"
              label="السنة الدراسية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects
                options={academicYears}
                className="takaful--request-select"
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="courses"
              label="دروس التقوية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="attended_program"
              label="البرامج التي تلقاها"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="teacher_evaluation"
              label="تقييم المعلم"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="guardian_evaluation"
              label="تقييم ولي الأمر"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="level_test_ids"
              label="إختبار تحديد المستوى"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <UploadInput
                accept="*"
                text="إختبار تحديد المستوى"
                icon={<UploadOutlined />}
                multiple={false}
                maxCount={1}
                onChange={(fileList) =>
                  handleFileChange(
                    fileList,
                    form.setFieldsValue,
                    "level_test_ids"
                  )
                }
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="certificate_achievement_ids"
              label="مرفقات الإنجازات و الشهادات"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <UploadInput
                accept="*"
                text="مرفقات الإنجازات و الشهادات"
                icon={<UploadOutlined />}
                multiple={true}
                maxCount={5}
                onChange={(fileList) =>
                  handleFileChange(
                    fileList,
                    form.setFieldsValue,
                    "certificate_achievement_ids"
                  )
                }
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="certificate_achievement"
              label="الإنجازات و الشهادات"
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <TextArea
                className="takaful--suggestions-complaints-textarea"
                rows={3}
                style={{ height: "4rem" }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify={"end"} dir="rtl" style={{ width: "100%" }}>
          <Col xxl={4} xl={4} lg={4} md={4} sm={9} xs={9}>
            <PrimaryButton
              style={{ width: "100%" }}
              onClick={() => {
                onFinish();
              }}
              title="إرسال"
              loading={loadingSend}
              disabled={loadingSend}
            />
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default AddRegistrationSchoolRequest;
